import React, { Component } from "react";
import PropTypes from "prop-types";
import MobilePage from "../MobilePage";
import $ from "jquery";
import _ from "lodash";

class MobilePages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: -1,
      x: 0
    };
  }

  findPos(obj) {
    var curtop = 0;
    if (obj.offsetParent) {
      do {
        curtop += obj.offsetTop;
      } while ((obj = obj.offsetParent));
      return [curtop];
    }
  }

  handleSelect(index, i, x, w) {
    let y = 0;

    y = this.findPos(document.getElementById("page" + Number(i)));

    $("#divScroll").animate({ scrollTop: y - 136 }, 400);

    this.setState({ activeIndex: index });

    let statex = -(this.refs.abc.getBoundingClientRect().x - 10);
    let wx = 0;
    let r = window.innerWidth / 2;
    if (statex === 0 && x + w / 2 < r) {
    } else {
      wx = x + w / 2 - r;

      $("#abcd").animate({ scrollLeft: wx }, 400);
    }
  }

  renderPages() {
    var pages = [];
    var active;
    var i = 1;

    var z = 0;
    var t = 0;
    var r = 0;

    var pagebreaks = _.filter(this.props.pages, { element_type: "25" });

    if (pagebreaks.length > 0) {
      this.props.pages.forEach((page, index) => {
        if (page.element_type === "25" && this.props.pageNums[i] === 1) {
          this.state.activeIndex === z - 1 - t
            ? (active = true)
            : (active = false);

          pages.push(
            <MobilePage
              active={active}
              ref={"tt" + i}
              index={r == 1 ? z - 1 : z}
              onClick={this.handleSelect.bind(this)}
              title={page.element_prompt}
              number={z - 1 - t}
              key={index}
            />
          );
          if (r === 1) {
            r = 0;
          }
          t = 0;
        } else {
          if (page.element_type === "25" && this.props.pageNums[i] === 0) {
            i += 1;
          } else {
            z += 1;

            if (page.element_type !== "24" && page.element_type !== "22") {
              t += 1;
            }
          }
        }
      });
    } else {
      let newpages = _.filter(this.props.pages, function(page) {
        return page.element_type !== "25";
      });

      newpages.forEach((page, index) => {
        if (page.element_params !== null) {
          if (page.element_params.show_in_menu !== undefined) {
            if (page.element_params.show_in_menu === "1") {
              this.state.activeIndex === i ? (active = true) : (active = false);

              pages.push(
                <MobilePage
                  active={active}
                  ref={"tt" + i}
                  index={i}
                  onClick={this.handleSelect.bind(this)}
                  title={page.element_prompt}
                  number={i}
                  key={index}
                />
              );
            }
          }
        }
        i += 1;
      });
    }
    if (pages.length === 0) {
      return <div></div>;
    }

    return (
      <div
        id="abc"
        ref="abc"
        style={{ whiteSpace: "nowrap", width: "100%", marginTop: "0px" }}
      >
        {pages}
      </div>
    );
  }

  render() {
    return <div>{this.renderPages()}</div>;
  }
}

MobilePages.propTypes = {
  pages: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  pageNums: PropTypes.array.isRequired,
  storeColour: PropTypes.object.isRequired
};

export default MobilePages;



// WEBPACK FOOTER //
// ./src/components/MobilePages/index.js